// src/utils/validateTracking.js

export const validateTracking = (payload, presentFields = []) => {
  const errors = [];

  const has = (type) => presentFields.includes(type);

  if (has("title") && (!payload.title || payload.title.trim() === "")) {
    errors.push("Title is required");
  }

  if (has("location") && (!payload.location || payload.location.trim() === "")) {
    errors.push("Location is required");
  }

  if (has("duration") && (!payload.duration || payload.duration.trim() === "")) {
    errors.push("Duration is required");
  }

  if (has("groupSize") && (!payload.groupSize || payload.groupSize.trim() === "")) {
    errors.push("Group Size is required");
  }

  if (has("description")) {
    if (!payload.description || payload.description.length === 0) {
      errors.push("At least one description is required");
    } else {
      payload.description.forEach((d, i) => {
        if (!d.data || d.data.trim() === "") {
          errors.push(`Description ${i + 1} cannot be empty`);
        }
      });
    }
  }

  if (has("galleryImage")) {
    if (!payload.galleryImages || payload.galleryImages.length === 0) {
      errors.push("Please add at least one gallery image");
    } else {
      const hasValidImage = payload.galleryImages.some(img => {
        const url = (img.url || "").trim();

        // 1. File uploaded (id હોય અને url ખાલી હોય)
        if (img.id && (!url || url === "")) return true;

        // 2. External URL (http/https)
        if (url.startsWith("http://") || url.startsWith("https://")) return true;

        // 3. Already saved image
        if (url.startsWith("/Uploads/")) return true;

        return false;
      });

      if (!hasValidImage) {
        errors.push("Please upload an image or paste a valid URL");
      }
    }
  }

  if (has("itinerary")) {
    if (!payload.itinerary || payload.itinerary.length === 0) {
      errors.push("Add at least one itinerary day");
    } else {
      const days = payload.itinerary.map(d => d.day);
      if (new Set(days).size !== days.length) {
        errors.push("Day numbers must be unique");
      }
      payload.itinerary.forEach((d, i) => {
        if (!d.day) errors.push(`Day ${i + 1}: Day number required`);
        if (!d.title?.trim()) errors.push(`Day ${d.day || i + 1}: Title required`);
        if (!d.description?.trim()) errors.push(`Day ${d.day || i + 1}: Description required`);
      });
    }
  }

  if (has("faq") && payload.faqs) {
    payload.faqs.forEach((f, i) => {
      if (!f.question?.trim()) errors.push(`FAQ ${i + 1}: Question required`);
      if (!f.answer?.trim()) errors.push(`FAQ ${i + 1}: Answer required`);
    });
  }


  if (has("tripInfo")) {
    payload.tripInfo.forEach((info, i) => {
      if (!info.type?.trim()) errors.push(`Trip Info ${i + 1}: Type is required`);
      if (!info.title?.trim()) errors.push(`Trip Info ${i + 1}: Title is required`);
      if (!info.value?.trim()) errors.push(`Trip Info ${i + 1}: Value is required`);
      if (!info.icon?.trim()) errors.push(`Trip Info ${i + 1}: Icon is required`);
    });
  }

  if (has("includedService")) {
    if (!payload.includedServices || payload.includedServices.length === 0) {
      errors.push("Please add at least one included service");
    } else {
      payload.includedServices.forEach((service, i) => {
        if (!service.name?.trim()) {
          errors.push(`Included Service ${i + 1}: Name is required`);
        }
      });
    }
  }


  if (has("excludedService")) {
    if (!payload.excludedServices || payload.excludedServices.length === 0) {
      errors.push("Please add at least one excluded service");
    } else {
      payload.excludedServices.forEach((service, i) => {
        if (!service.name?.trim()) {
          errors.push(`Excluded Service ${i + 1}: Name is required`);
        }
      });
    }
  }

  if (has("socialLink")) {
    if (!payload.socialLinks?.length) {
      errors.push("Please add at least one social link");
    } else {
      payload.socialLinks.forEach((link, i) => {
        if (!link.platform?.trim()) errors.push(`Social Link ${i + 1}: Platform is required`);
        if (!link.url?.trim()) errors.push(`Social Link ${i + 1}: URL is required`);
      });
    }
  }


  if (has("mapEmbedUrl")) {
    if (!payload.mapEmbedUrl?.trim()) {
      errors.push("Map Embed URL is required");
    }
  }


  if (has("checkList")) {
    if (!payload.checkList?.length) {
      errors.push("Please add at least one check list item");
    } else {
      payload.checkList.forEach((item, i) => {
        if (typeof item === "string" && !item.trim()) {
          errors.push(`Check List Item ${i + 1} cannot be empty`);
        }
      });
    }
  }


  if (has("tourBenefits")) {
    if (!payload.tourBenefits?.length) {
      errors.push("Please add at least one tour benefit");
    } else {
      payload.tourBenefits.forEach((item, i) => {
        if (typeof item === "string" && !item.trim()) {
          errors.push(`Tour Benefit ${i + 1} cannot be empty`);
        }
      });
    }
  }

  if (has("pricing")) {
    if (!payload.pricing || payload.pricing.length === 0) {
      errors.push("Please add at least one pricing option");
    } else {
      payload.pricing.forEach((p, i) => {
        if (!p.price || p.price <= 0) {
          errors.push(`Pricing ${i + 1}: Price must be greater than 0`);
        }
        if (!p.type || !["adult", "child"].includes(p.type)) {
          errors.push(`Pricing ${i + 1}: Type must be Adult or Child`);
        }

      });
    }
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};
